import * as PlayerCardPersonalInfoReducer from './reducers/index.reducer'
import * as PlayerCardPersonalInfoTypes from './constants'
import * as PlayerCardSelectors from './selectors'

import * as PlayerCardActions from './actions/index.actions'

export { PlayerCardPersonalInfoTypes, PlayerCardSelectors, PlayerCardActions }

export default PlayerCardPersonalInfoReducer
